<template>
  <div>
    <v-navigation-drawer app v-model="drawerAux" absolute temporary>
      <v-list
        subheader
        style="max-height: 90vh; overflow-y: scroll; overflow-x: hidden"
      >
        <v-list-item>
          <v-list-item-avatar
            color="grey"
            class="userimage"
          ></v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ user.fullname }}</v-list-item-title>
            <v-list-item-subtitle>{{ user.ramal }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item-group v-model="rota" color="primary">
          <v-list-item
            value="Atendimentos"
            link
            @click="
              drawerAux = false;
              rota = `Atendimentos`;
              selectAtendimento(null);
              selectNewCall(null);
              selectCliente(null);
              $router.push({ path: '/home' });
            "
          >
            <v-list-item-icon>
              <v-icon>mdi-account-box</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ t("atendimentos") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            value="Historico"
            link
            @click="
              drawerAux = false;
              rota = `Historico`;
              selectAtendimento(null);
              selectNewCall(null);
              selectCliente(null);
              $router.push({ path: '/historico' });
            "
          >
            <v-list-item-icon>
              <v-icon>mdi-history</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ t("historico") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            value="Contatos"
            link
            @click="
              drawerAux = false;
              rota = `Contatos`;
              selectAtendimento(null);
              selectNewCall(null);
              selectCliente(null);
              $router.push({ path: '/contatos' });
            "
          >
            <v-list-item-icon>
              <v-icon>mdi-book-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ t("contatos") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item
            value="Dashboard"
            link
            @click="
              drawerAux = false;
              rota = `Dashboard`;
              selectAtendimento(null);
              selectNewCall(null);
              $router.push({ path: '/dashboard' });
            "
          >
            <v-list-item-icon>
              <v-icon>mdi-chart-line</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ t("dashboard") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
        </v-list-item-group>
        <v-divider></v-divider>
        <template v-if="user.modo === `F`">
          <v-subheader>{{ t("minhasFilas") }}</v-subheader>
          <v-list-item v-for="(item, index) in user.filas" :key="index">
            <v-list-item-title>{{ item.fila }}</v-list-item-title>
            <v-list-item-action>
              <v-switch
                v-model="filaStatus[index].value"
                @change="queueEvent(filaStatus[index])"
                color="success"
              ></v-switch>
            </v-list-item-action>
          </v-list-item>
        </template>
        <template v-else>
          <v-list-item>
            <v-list-item-title>{{ t("filaUnica") }}</v-list-item-title>
            <v-list-item-action>
              <v-switch
                v-model="filaUnicaAux"
                @change="queueEvent()"
                color="success"
              ></v-switch>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
      <!-- <Homebar /> -->
    </v-navigation-drawer>

    <v-toolbar color="grey lighten-2" elevation="1" dense>
      <v-app-bar-nav-icon @click="drawerAux = true"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-btn icon @click="modalEmail = true">
        <v-icon>mdi-email</v-icon>
      </v-btn>
      <v-btn icon @click="modalWhats = true">
        <v-icon>mdi-whatsapp</v-icon>
      </v-btn>
      <v-btn icon v-show="config.webrtc" @click="modalDial = true">
        <v-icon>mdi-phone-dial</v-icon>
      </v-btn>
      <v-btn icon v-show="config.webrtc" @click="modalAgendamento = true">
        <v-icon>mdi-calendar-clock</v-icon>
      </v-btn>
      <v-dialog v-model="modalDial">
        <Dial v-on:update="modalDial = $event" />
      </v-dialog>
    </v-toolbar>

    <NovoWhats :open="modalWhats" v-on:update="closeModalWhats($event)" />
    <NovoEmail :open="modalEmail" v-on:update="closeModalEmail($event)" />
    <NovaLigacao :open="modalLigacao" v-on:update="closeModalLigacao($event)" />
    <Agendamento
      :open="modalAgendamento"
      v-on:update="closeModalAgendamento($event)"
    />
  </div>
</template>
   
<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";
import NovoWhats from "../dialogs/NovoWhats";
import NovoEmail from "../dialogs/NovoEmail";
import NovaLigacao from "../dialogs/NovaLigacao";
import Homebar from "../bars/AgenteStatus.vue";
import Dial from "../Home";
import Agendamento from "../dialogs/Agendamentos.vue";
export default {
  name: "Home-bar",
  components: {
    NovoWhats,
    NovoEmail,
    NovaLigacao,
    Dial,
    Agendamento,
    Homebar,
  },
  props: {
    title: { type: String, default: "Title" },
  },
  data: () => ({
    config: JSON.parse(localStorage.getItem("config")),
    modalWhats: false,
    modalEmail: false,
    modalLigacao: false,
    modalAgendamento: false,
    drawerAux: false,
    rota: null,
    modalDial: false,
    filaUnicaAux: false,
  }),
  created() {
    if (this.user.modo === "T") {
      for (let fila of this.user.filas) {
        this.queueAdd({ data: fila, user: this.user });
      }
    }
  },
  methods: {
    closeModalWhats() {
      this.modalWhats = false;
    },
    closeModalLigacao() {
      this.modalLigacao = false;
    },
    closeModalAgendamento() {
      this.modalAgendamento = false;
    },
    closeModalEmail() {
      this.modalEmail = false;
    },
    ...mapActions("auth", [
      "queueAdd",
      "queueRemove",
      "queuePause",
      "queueUnpause",
    ]),
    ...mapActions("xc", ["selectAtendimento", "selectCliente"]),
    ...mapActions("sip", ["selectNewCall"]),

    queueEvent(data = null) {
      if (!data && this.user.modo !== `F`) {
        if (this.filaUnicaAux) {
          console.log(`queueadd`);
          for (let fila of this.user.filas) {
            this.queueAdd({ data: fila, user: this.user });
          }
        } else {
          console.log(`queueRemove`);
          for (let fila of this.user.filas) {
            this.queueRemove({ data: fila, user: this.user });
          }
        }
        return;
      }
      if (data.value) {
        this.queueAdd({ data: data, user: this.user });
      } else {
        this.queueRemove({ data: data, user: this.user });
      }
    },
  },
  computed: {
    ...mapState("xc", {
      pausas: (state) => state.pausas,
    }),
    ...mapState("auth", {
      user: (state) => state.user,
      status: (state) => state.status,
      filas: (state) => state.user.filas,
      pausaMotivo: (state) => state.user.motivoPausa,
      userStatus: (state) => state.user.status,
      filaUnica: (state) => state.filaUnica,
    }),
    filaStatus: function () {
      return this.user.filas;
    },
  },
  watch: {
    filaUnica(nw) {
      this.filaUnicaAux = nw;
    },
    userStatus(nw) {
      //caso fique indisponivel vamos remover as pausas
      if (nw) {
        this.lastQueueEvent = new Date();
        if (nw !== 10 && nw !== 1) {
          if (this.pausaStatus && this.pausaStatus.length > 0) {
            for (let p of this.pausaStatus) {
              p.value = false;
            }
          }
        }
      }
    },
  },
};
</script>